<script setup lang="ts">
import type { Order } from "@/model/backend/order"

defineProps<{ order: Order }>()
</script>
<template>
    <div v-if="order.paymentReceived" class="circle-icon bg-primary">
        <i class="fa fa-check"></i>
    </div>

    <div v-else class="circle-icon">
        <i class="fa fa-times"></i>
    </div>
</template>
